import React from "react";
import { Flame, Leaf, WheatOff } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sides = [{
  name: "אנטיפסטי",
  description: "מגוון ירקות טריים מתובלים בשמן זית מלח ופלפל גס ועשבי תיבול",
  price: "18 ₪",
  isVeg: true,
  isSpicy: false,
  isGF: true
}, {
  name: "אורז מפונק",
  description: "כורכום/פפריקה שום קונפי ירק קצוץ",
  price: "22 ₪",
  isVeg: true,
  isSpicy: false,
  isGF: false
}, {
  name: "נזיד בוקרים",
  description: "שעועית לבנה בתיבול פיקנטי עם קוביות בשר בקר ומח עצם",
  price: "24 ₪",
  isVeg: false,
  isSpicy: true,
  isGF: true
}, {
  name: "שום קונפי",
  description: "בשמן זית ועשבי תיבול",
  price: "16 ₪",
  isVeg: true,
  isSpicy: false,
  isGF: true
}, {
  name: "צ'ימצ'ורי",
  description: "פטרוזיליה , כוסברה , שום, בצל סגול, שמן זית, חומץ לימון ופלפל צ'ילי",
  price: "16 ₪",
  isVeg: true,
  isSpicy: false,
  isGF: true
}];
const sauces = [{
  name: "פקאן",
  description: "המתכון הסודי שלנו",
  price: "5 ₪",
  isVeg: true,
  isSpicy: false
}, {
  name: "היקורי",
  description: "המתכון הסודי שלנו",
  price: "5 ₪",
  isVeg: true,
  isSpicy: false
}, {
  name: "תפוח",
  description: "המתכון הסודי שלנו",
  price: "5 ₪",
  isVeg: true,
  isSpicy: false
}, {
  name: "דובדבן",
  description: "המתכון הסודי שלנו",
  price: "5 ₪",
  isVeg: true,
  isSpicy: false
}, {
  name: "מיסקיט",
  description: "המתכון הסודי שלנו",
  price: "5 ₪",
  isVeg: true,
  isSpicy: false
}];
export default function SidesAndSauces() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="תוספות-ורטבים" className="dark bg-background text-foreground py-20 relative overflow-hidden" dir="rtl">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,hsl(var(--secondary)/0.1),transparent_40%)] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-primary">סוגי עישון ותוספות</h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">השלימו את חווית הבשרים עם סוגי העישון המיוחדים שלנו ומגוון התיבולים המקוריים שנעשים במקום.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            {}
            <div className="space-y-8">
              <div className="flex items-center gap-3 mb-6 border-b-2 border-primary/20 pb-2">
                <h3 className="text-2xl font-bold text-foreground">תוספות&nbsp;</h3>
              </div>
              <div className="space-y-1">
                {sides.map((item, i) => <div key={i} data-index={i} className="group flex flex-col sm:flex-row sm:items-center justify-between py-5 border-b border-secondary hover:border-primary/50 transition-colors duration-300">
                    <div className="flex-1 pl-4">
                      <div className="flex items-center gap-3 mb-1">
                        <span className="text-xl font-medium group-hover:text-primary transition-colors">
                          {item.name}
                        </span>
                        <div className="flex gap-1.5">
                          {item.isSpicy && <Badge variant="destructive" className="h-5 px-1.5 rounded-sm" title="חריף">
                              <Flame className="size-3 fill-current" />
                            </Badge>}
                          {item.isVeg && <Badge variant="secondary" className="h-5 px-1.5 rounded-sm bg-secondary text-secondary-foreground border border-secondary-foreground/10" title="צמחוני">
                              <Leaf className="size-3" />
                            </Badge>}
                          {item.isGF && <Badge variant="outline" className="h-5 px-1.5 rounded-sm border-muted-foreground/30 text-muted-foreground" title="ללא גלוטן">
                              <WheatOff className="size-3" />
                            </Badge>}
                        </div>
                      </div>
                      <p className="text-sm text-muted-foreground">
                        {item.description}
                      </p>
                    </div>
                    <div className="mt-2 sm:mt-0 shrink-0">
                      <span className="text-lg font-bold text-primary font-mono">
                        {item.price}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            {}
            <div className="space-y-8">
              <div className="flex items-center gap-3 mb-6 border-b-2 border-primary/20 pb-2">
                <h3 className="text-2xl font-bold text-foreground">סוגי עישון (טעם וריח)</h3>
              </div>
              <div className="space-y-1">
                {sauces.map((item, i) => <div key={i} data-index={i} className="group flex flex-col sm:flex-row sm:items-center justify-between py-5 border-b border-secondary hover:border-primary/50 transition-colors duration-300">
                    <div className="flex-1 pl-4">
                      <div className="flex items-center gap-3 mb-1">
                        <span className="text-xl font-medium group-hover:text-primary transition-colors">
                          {item.name}
                        </span>
                        <div className="flex gap-1.5">
                          {item.isSpicy && <Badge variant="destructive" className="h-5 px-1.5 rounded-sm" title="חריף">
                              <Flame className="size-3 fill-current" />
                            </Badge>}
                          {item.isVeg && <Badge variant="secondary" className="h-5 px-1.5 rounded-sm bg-secondary text-secondary-foreground border border-secondary-foreground/10" title="צמחוני">
                              <Leaf className="size-3" />
                            </Badge>}
                        </div>
                      </div>
                      <p className="text-sm text-muted-foreground">
                        {item.description}
                      </p>
                    </div>
                    <div className="mt-2 sm:mt-0 shrink-0">
                      <span className="text-lg font-bold text-primary font-mono">
                        {item.price}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}